import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface IrandomCombMain {
  main_combination_id: string;
  codevar: string;
  phonenumber: string;
}

const submitQuestionMain = async (
  queId: number,
  answer: string,
  combId: string
): Promise<IrandomCombMain | boolean> => {
  try {
    const config: AxiosRequestConfig = {
      method: "POST",
      // url: `${process.env.REACT_APP_HOST}/ultra3/add-entry`, http://ultra-cib.malihetz.complete-inbox.com
      // url: `https://quiz-back.firebird.rs/api/ultra/submit-question-main`,
      
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/submit-question-main`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/submit-question-main`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        queId: queId,
        answer: answer,
        combId: combId,
      },
    };
    const response: AxiosResponse = await axios(config);
    const { data } = response.data;

    return data;
  } catch (error) {

    return false;
  }
};

export default submitQuestionMain;
